import {useQuartermaster} from '../../../contexts/use-quartermaster'
import {StyledArtefactName} from './artefactname.styled'

export function ArtefactName(): JSX.Element {
    const {filename} = useQuartermaster()
    return <StyledArtefactName>Artefact: {filename}</StyledArtefactName>
}
